import { ReduceStore } from 'flux/utils';
import { List } from 'immutable';
import AppDispatcher from '../AppDispatcher';
import Constants from '../Constants';

import { User } from './UserStore';

class DaemonStore extends ReduceStore {
  getInitialState() {
    return new List();
  }

  reduce(state, action) {
    switch (action.actionType) {
      case Constants.Daemons.DAEMONS_RECEIVED:
        return new List(action.daemonUsers.map(
          user => new User(user))).sortBy(user => user.get('email'));
      default:
        return state;
    }
  }

  get(id, defaultValue = null) {
    return this.getState().get(id, defaultValue);
  }

  getByEmail(email) {
    return this.getState().filter(daemon => daemon.email === email).first();
  }
}

const instance = new DaemonStore(AppDispatcher);
export default instance;
